<div class="coworking-spaces">
  <div class="coworking-spaces-container">
    <div
      *ngFor="let space of form['controls']; let i = index"
      class="coworking-spaces-space"
      [formGroup]="space"
    >
      <div
        (click)="cleanControl(space, i)"
        *ngIf="i !== 0"
        class="delete-button"
      >
        <span> <img [src]="getCloseSvg" alt="delete" /> </span>
      </div>
      <cowing-input-media
        [isForm]="true"
        [control]="space.get('imagePath')"
        [name]="'image_' + i"
        [acceptPhoto]="true"
        [inputStyle]="EInputMediaStyleType.roundedTop"
      >
      </cowing-input-media>
      <div class="coworking-spaces-space-container">
        <cowing-input
          [inputStyle]="EInputStyleType.Responsive"
          [iconShow]="true"
          [isForm]="true"
          [type]="'text'"
          [placeholder]="'coworking.spaces.title' | translate"
          [value]="space.name"
          [control]="space.get('name')"
        >
        </cowing-input>

        <cowing-input-dropdown
          *ngIf="spacesType.length"
          [inputStyle]="EDropdownStyleType.Clean"
          [type]="'object'"
          [iconShow]="true"
          [isForm]="true"
          [control]="space.get('spaceCategory')"
          [options]="spacesType"
        >
        </cowing-input-dropdown>

        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.seats" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.capacity"
            [control]="space.get('capacity')"
          ></cowing-input>
        </div>
        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.quantity" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.quantity"
            [control]="space.get('quantity')"
          ></cowing-input>
        </div>
        <!-- <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.available" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.available"
            [control]="space.get('available')"
          ></cowing-input>
        </div> -->
        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.price-hour" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.price_hour"
            [iconShow]="true"
            [iconName]="'euroIcon'"
            [control]="space.get('price_hour')"
          >
          </cowing-input>
        </div>
        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.price-day" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.price_day"
            [iconShow]="true"
            [iconName]="'euroIcon'"
            [control]="space.get('price_day')"
          >
          </cowing-input>
        </div>
        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.price-week" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.price_week"
            [iconShow]="true"
            [iconName]="'euroIcon'"
            [control]="space.get('price_week')"
          >
          </cowing-input>
        </div>
        <div class="coworking-spaces-space-container-section">
          <span>{{ "coworking.spaces.price-month" | translate }}</span>
          <cowing-input
            [inputStyle]="EInputStyleType.Number"
            [isForm]="true"
            [type]="'number'"
            [value]="space.price_month"
            [iconShow]="true"
            [iconName]="'euroIcon'"
            [control]="space.get('price_month')"
          >
          </cowing-input>
        </div>
      </div>
    </div>
    <div class="coworking-spaces-button">
      <cowing-button
        [type]="EButtonType.Rounded"
        [label]="'coworking.spaces.add-space' | translate"
        [iconShow]="true"
        [iconName]="'addIcon'"
        (event)="addSpace()"
      ></cowing-button>
    </div>
  </div>
  <span> {{ "coworking.spaces.disclaimer-prices" | translate }}</span>

  <div *ngIf="isEditingInfo" class="actions-footer">
    <cowing-button
      [label]="'coworking.back' | translate"
      [type]="EButtonType.RoundedSecondary"
      [iconShow]="false"
      (event)="goBack()"
    >
    </cowing-button>
    <cowing-button
      [disabled]="isDisabledForm"
      [label]="'Guardar'"
      [type]="EButtonType.Rounded"
      [iconShow]="false"
      (event)="modifySpaces()"
    >
    </cowing-button>
  </div>
</div>
